import { Component, Input } from '@angular/core';
import { PaymentService } from 'src/app/pages/payment/services/payment/payment.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-course-details',
  templateUrl: './course-details.component.html',
  styleUrls: ['./course-details.component.css'],
})
export class CourseDetailsComponent {
  @Input() data!: any;
  @Input() language!: string;
  isAlBorshama: boolean = environment.projectName === 'Al-Bershama';

  constructor(private paymentService: PaymentService) {}

  ngOnInit() {
    console.log('Course Include Data:', this.data.courseInfo.courseInclude);
  }

  buyCourse() {
    console.log('Buy Course:', this.data);
  }
}
